(function () {
    'use strict';

    angular.module("imApp").factory("paymentPlanService", ['$ihttp', function ($ihttp) {
        let service = {
            getPaymentPlan: function (parms) {
                return $ihttp.post({
                    method: 2738,
                    parameters: parms || {}
                });
            },
            getDueDate: function (parms) {
                return $ihttp.post({
                    method: 2739,
                    parameters: parms || {}
                });
            },
            calculatePaymentPlan: function (mergeObj) {
                return $ihttp.post({
                    method: 2749,
                    parameters: mergeObj
                });
            },
            createObj: function (edit) {
                return $ihttp.post({
                    method: 2742,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2740,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2741,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
